module.exports = __webpack_public_path__ + "ec998f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginElements/img/SYR_OCEANIC_Logo.png
// module id = 1445
// module chunks = 0 9